import { Http } from "@/domain/repositories/Http";

export class HttpFetch implements Http {
  basePath: string;

  constructor() {
    const backendUrl = process.env.NEXT_PUBLIC_BACKEND_URL;
    if (!backendUrl) {
      throw new Error("Missing environment variable NEXT_PUBLIC_BACKEND_URL");
    }

    this.basePath = backendUrl;
  }

  async get(...args: Parameters<Http["get"]>) {
    const [url, config] = args;

    const mergeConfig = {
      ...config,
      headers: {
        "Content-Type": "application/json",
        ...config?.headers,
      },
      next: { tags: config?.tags },
    };

    const response = await fetch(this.basePath + url, {
      method: "GET",
      ...mergeConfig,
    });
    return response.json();
  }

  async post(...args: Parameters<Http["post"]>) {
    const [url, params, config] = args;

    const mergeConfig = {
      ...config,
      headers: {
        // "Content-Type": "application/json",
        ...config?.headers,
      },
      next: { tags: config?.tags },
    };

    const response = await fetch(this.basePath + url, {
      method: "POST",
      ...mergeConfig,
      body:
        mergeConfig?.headers?.["Content-Type"] === "application/json"
          ? JSON.stringify(params)
          : params,
    });
    return response.json();
  }

  async put(...args: Parameters<Http["put"]>) {
    const [url, params, config] = args;

    const mergeConfig = {
      ...config,
      headers: {
        "Content-Type": "application/json",
        ...config?.headers,
      },
      next: { tags: config?.tags },
    };

    const response = await fetch(this.basePath + url, {
      method: "PUT",
      ...mergeConfig,
      body: JSON.stringify(params),
    });
    return response.json();
  }

  async delete(...args: Parameters<Http["delete"]>) {
    const [url, params, config] = args;

    const mergeConfig = {
      ...config,
      headers: {
        "Content-Type": "application/json",
        ...config?.headers,
      },
      next: { tags: config?.tags },
    };

    const response = await fetch(this.basePath + url, {
      method: "DELETE",
      ...mergeConfig,
      body: JSON.stringify(params),
    });
    return response.json();
  }
}
